'use client';

var translations = {
    All: 'Tất cả',
    Back: 'Trở về',
    Apply: 'Áp dụng',
    Cancel: 'Hủy',
    Select: 'Chọn',
    Search: 'Tìm kiếm',
    'Remove all': 'Xóa tất cả',
    'No result': 'Không có kết quả',
    'You have selected up to three options': 'Bạn đã chọn tối đa ba tuỳ chọn',
    districts: 'quận/huyện'
};

export { translations as default };
//# sourceMappingURL=translations.js.map
